import React, { useEffect, useState } from "react";
import { getApi, postApi } from "../AppApis";
import config from "../../config";
import { RxCross1 } from "react-icons/rx";
import customer_avatar from "../../assets/images/customer_avatar.png";
import { toast } from "react-toastify";

export default function ShareDocumentModal({ selectedFile, onClose }) {
    const [isLoading, setIsLoading] = useState(false);
    const [userLists, setUserLists] = useState([]);
    const [customerSupports, setCustomerSupports] = useState([]);
    const [email, setEmail] = useState("");
    const [sendingToChat, setSendingToChat] = useState(new Set());
    const getUserChatList = async () => {
        const response = await getApi("/messaging/conversations");
        if (response?.response) {
            const filterCustomerSupports = response.response.data.filter((item) => item.first_name === "Customer" || !item.first_name);
            setCustomerSupports(filterCustomerSupports);
            const filterUsers = response.response.data.filter((item) => item.first_name !== "Customer" && item.first_name);
            setUserLists(filterUsers);
        }
    };
    useEffect(() => {
        getUserChatList();
    }, []);

    const handleSendDocument = async (item) => {
        const conversationId = item?.id;

        // Prevent duplicate requests
        if (sendingToChat.has(conversationId)) {
            return;
        }

        setSendingToChat((prev) => new Set(prev).add(conversationId));

        try {
            const payload = {
                conversation_id: conversationId,
                media_url: selectedFile.url,
                file_data: "string",
                file_name: selectedFile.name,
                file_type: "image",
                message_type: "image",
            };
            const response = await postApi("/messaging/send-message", payload);
            toast.success("Document Sent Successfully", { toastId: "document_sent" });

            onClose();
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setSendingToChat((prev) => {
                const newSet = new Set(prev);
                newSet.delete(conversationId);
                return newSet;
            });
        }
    };

    const onSendEmail = async () => {
        // Prevent duplicate requests
        if (isLoading) {
            return;
        }

        setIsLoading(true);
        try {
            const url = `/documents/share-document`;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email && emailRegex.test(email)) {
                const response = await postApi(url, {
                    message: "Please check out this document",
                    document_id: selectedFile.id,
                    recipient_email: email,
                    project_type: "onmls",
                });
                toast.success("Email sent successfully", { toastId: "email_sent" });
                onClose();
            } else {
                toast.error("Please enter a valid email", { toastId: "invalid_email" });
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="tw-p-5 tw-py-10 tw-max-h-full tw-overflow-y-auto">
            <div className="tw-flex tw-justify-between tw-w-full ">
                <p className="tw-text-[20px] tw-text-black tw-font-[600] "> Share Document</p>
                <button className="tw-bg-[#EAEEF4] tw-h-[35px] tw-w-[35px] tw-rounded-full tw-flex tw-justify-center tw-items-center">
                    <RxCross1 onClick={onClose} />
                </button>
            </div>
            <p className="tw-text-[#767676]">Securely share your document with a user or support.</p>
            <p className="tw-text-black tw-mt-3">Email</p>
            <div className="tw-flex tw-w-full tw-justify-between tw-gap-5">
                <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    className="tw-border tw-border-[#D0D5DD] tw-rounded-md tw-w-full tw-py-2 tw-px-3"
                />
                <button
                    onClick={onSendEmail}
                    disabled={isLoading}
                    className={`tw-px-5 tw-py-2 tw-rounded-md tw-text-white ${isLoading ? "tw-bg-gray-400 tw-cursor-not-allowed" : "tw-bg-primary"}`}
                >
                    {isLoading ? "Sending..." : "Send"}
                </button>
            </div>
            <p className="tw-text-[#767676] tw-my-5 tw-text-[12px]">Securely share your document with a user or support.</p>
            {userLists.length > 0 && (
                <>
                    <p className="tw-text-[20px] tw-text-black tw-font-[600] "> Send to Another User</p>

                    {userLists?.map((item, index) => {
                        let name = item.first_name ? `${item.first_name} ${item.last_name}` : item.property_address;
                        return (
                            <div className=" tw-w-full tw-rounded-md tw-flex tw-justify-between tw-items-center tw-p-3 tw-mt-1">
                                <div className="tw-flex tw-items-center tw-gap-3">
                                    <img src={item?.profile_pic ?? customer_avatar} className="tw-w-[40px] tw-h-[40px] tw-rounded-full" alt="" />
                                    <div>
                                        <p className="tw-text-black">{name}</p>
                                        <p className="tw-text-[#767676] tw-text-[10px] tw-mt-1">{item.property_address}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => handleSendDocument(item)}
                                    disabled={sendingToChat.has(item?.id)}
                                    className={`tw-px-7 tw-py-2 tw-rounded-md tw-text-white tw-h-[35px] ${sendingToChat.has(item?.id) ? "tw-bg-gray-400 tw-cursor-not-allowed" : "tw-bg-primary"}`}
                                >
                                    {sendingToChat.has(item?.id) ? "Sending..." : "Send"}
                                </button>
                            </div>
                        );
                    })}
                </>
            )}
            {customerSupports.length > 0 && (
                <>
                    <p className="tw-text-[20px] tw-text-black tw-font-[600] "> Customer Support</p>

                    {customerSupports?.map((item, index) => {
                        return (
                            <div className=" tw-w-full tw-rounded-md tw-flex tw-justify-between tw-items-center tw-p-3 tw-mt-1">
                                <div className="tw-flex tw-items-center tw-gap-3">
                                    <img src={customer_avatar} className="tw-w-[40px] tw-h-[40px] tw-rounded-full" alt="" />
                                    <div>
                                        <p className="tw-text-black">{"Customer Service"}</p>
                                        <p className="tw-text-[#767676] tw-text-[10px] tw-mt-1">{item.property_address}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => handleSendDocument(item)}
                                    disabled={sendingToChat.has(item?.id)}
                                    className={`tw-px-7 tw-py-2 tw-rounded-md tw-text-white tw-h-[35px] ${sendingToChat.has(item?.id) ? "tw-bg-gray-400 tw-cursor-not-allowed" : "tw-bg-primary"}`}
                                >
                                    {sendingToChat.has(item?.id) ? "Sending..." : "Send"}
                                </button>
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
}
